import React, { useState, useEffect } from 'react';
import './Hero.css';
import profilePhoto from './icon.jpeg';
const roles = [
  'ML Engineer',
  'AI Researcher',
  'Full-Stack Developer',
  'Hackathon Winner',
  'Startup Founder',
];

export default function Hero() {
  const [roleIndex, setRoleIndex] = useState(0);
  const [displayed, setDisplayed] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const current = roles[roleIndex];
    let timeout;

    if (!isDeleting && displayed.length < current.length) {
      timeout = setTimeout(() => setDisplayed(current.slice(0, displayed.length + 1)), 80);
    } else if (!isDeleting && displayed.length === current.length) {
      timeout = setTimeout(() => setIsDeleting(true), 2000);
    } else if (isDeleting && displayed.length > 0) {
      timeout = setTimeout(() => setDisplayed(current.slice(0, displayed.length - 1)), 40);
    } else if (isDeleting && displayed.length === 0) {
      setIsDeleting(false);
      setRoleIndex((i) => (i + 1) % roles.length);
    }

    return () => clearTimeout(timeout);
  }, [displayed, isDeleting, roleIndex]);

  return (
    <section id="hero" className="hero">
      <div className="hero-inner">
        <div className="hero-content">
          <div className="hero-greeting fade-up" style={{ animationDelay: '0.1s' }}>
            <span className="greeting-line">
              <span className="terminal-prompt">~/krish $</span>
              <span className="greeting-text"> hello, world</span>
            </span>
          </div>

          <h1 className="hero-name fade-up" style={{ animationDelay: '0.3s' }}>
            Krish<br />
            <span className="name-accent">Kumar</span>
          </h1>

          <div className="hero-role fade-up" style={{ animationDelay: '0.5s' }}>
            <span className="role-prefix">// </span>
            <span className="role-text">{displayed}</span>
            <span className="cursor-blink">|</span>
          </div>

          <p className="hero-bio fade-up" style={{ animationDelay: '0.7s' }}>
            BE student at <span className="highlight">Thapar Institute of Engineering & Technology</span>.
            Building intelligent systems — from real-time AI voicebots to ML pipelines for Government of India.
            2× Hackathon Award Winner. Former Startup CEO.
          </p>

          <div className="hero-actions fade-up" style={{ animationDelay: '0.9s' }}>
            <a href="#projects" className="btn-primary">
              view my work
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
            <a href="#contact" className="btn-secondary">get in touch</a>
          </div>

          <div className="hero-stats fade-up" style={{ animationDelay: '1.1s' }}>
            <div className="stat">
              <span className="stat-num">2+</span>
              <span className="stat-label">years exp</span>
            </div>
            <div className="stat-divider" />
            <div className="stat">
              <span className="stat-num">3×</span>
              <span className="stat-label">awards</span>
            </div>
            <div className="stat-divider" />
            <div className="stat">
              <span className="stat-num">20+</span>
              <span className="stat-label">tech stack</span>
            </div>
          </div>
        </div>

        <div className="hero-visual fade-up" style={{ animationDelay: '0.4s' }}>
          <div className="photo-frame">
            <div className="photo-glow" />
            <div className="photo-border" />
            {
            <img src={profilePhoto} alt="Krish Kumar" className="profile-photo" />
            
            /* 
              ============================
              ADD YOUR PHOTO HERE!
              Replace the div below with:
              <img src="YOUR_PHOTO_URL_HERE" alt="Krish Kumar" className="profile-photo" />
              
              To get your LinkedIn photo:
              1. Go to your LinkedIn profile
              2. Click your profile picture
              3. Right-click > "Copy image address"
              4. Paste that URL as src above
              ============================
            */}
            <div className="photo-placeholder">
              {/* <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg> */}
              {/* <span>Add your photo here</span> */}
            </div>
            <div className="photo-tag">
              <span className="dot" />&nbsp;available for opportunities
            </div>
          </div>

          <div className="floating-card card-1">
            <span className="card-icon">🏆</span>
            <div>
              <div className="card-title">HackSecureX 2026</div>
              <div className="card-sub">1st Runner Up · $500</div>
            </div>
          </div>

          <div className="floating-card card-2">
            <span className="card-icon">🤖</span>
            <div>
              <div className="card-title">MoSPI Research</div>
              <div className="card-sub">Govt. of India · Active</div>
            </div>
          </div>
        </div>
      </div>

      <div className="scroll-indicator">
        <div className="scroll-line" />
        <span>scroll</span>
      </div>
    </section>
  );
}
